<template>
<moo-dialog custom-class="common-dialog folder-dialog" :append-to-body="true" :title="$t('新建文件夹#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1')" :visible.sync="folderVisible" width="480px" :before-close="() => handleFolderDialog(false)">
        <div class="content">
            <div class="folder-input">
                <svg-icon class-name="folder-icon" icon-class="cloud-folder"></svg-icon>
                <moo-input maxlength="255" @keyup.enter.native="handleCreateFolder" class="common-input" v-model="folderName" :placeholder="$t('请输入名称#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1')"></moo-input>
            </div>
            <div class="folder-path">{{ path }}</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <moo-button class="cancel" @click="folderVisible = false">{{$t("取 消#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1")}}</moo-button>
            <moo-button class="submit" type="primary" @click="handleCreateFolder">{{$t("确 定#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1")}}</moo-button>
        </span>
    </moo-dialog>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { createFolder } from '@/api/cloudHome';
import { debounce } from '@/utils/lodash';
import { mapState, mapActions } from "vuex";

export default {
  props: {
    folderPath: {
      type: String,
      default: intl.$t("我的文件#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1")
    }
  },
  name: 'MkdirDialog',
  components: {
  },
  data() {
    return {
      folderVisible: false,
      folderName: ''
    };
  },
  methods: {
    handleFolderDialog(value) {
      this.folderVisible = value;
      if (value) {
        this.folderName = intl.$t("未命名文件夹#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1");
      } else {
        this.folderName = '';
      }
    },
    handleCreateFolder: debounce(async function () {
      const regex = /[\\/:*?"<>|]/;
      if (regex.test(this.folderName)) {
        this.$message({ message: intl.$t("新建失败，文件名不能包含非法字符: / : * ? < > | '#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1"), type: 'error' });
        return;
      }

      const ownId = this.spaceId + "_" + this.userId + "_doc";

      const options = {
        checkName: true,
        fileName: this.folderName,
        parentId: ownId,
        // path: this.paths,
        type: "FILE"
      };
      try {
        const { code, message, data = {} } = await createFolder(options);
        if (code == 200) {
          this.$emit('refresh');
          this.$message({ message: intl.$t("创建成功#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1"), type: 'success' });
          this.handleFolderDialog(false);
        } else {
          this.$message({ message, type: 'error' });
        }
      } catch {
        this.$message({ message: intl.$t("创建失败#!!!#src/pages/CloudHome/components/mkdirDialog.vue_1"), type: 'error' });
      }
    })
  },
  computed: {
    ...mapState({
      spaceId: (state) => state.spaceId,
      userId: (state) => state.userId
    }),
    path() {
      return this.folderPath + '/' + this.folderName;
    }
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {

  }
};
</script>

<style lang="scss">
.common-dialog {
    border-radius: 8px !important;

    .moo-dialog__header {
        font-size: 17px;
        color: #000;
        font-weight: 500;
        box-shadow: 0 0.5px rgba(0, 0, 0, .11);
    }

    .moo-dialog__footer {
        height: 50px;
        box-shadow: 0 -0.5px rgba(0, 0, 0, .11);

        .dialog-footer {
            .cancel {
                outline: none;
                padding: 0;
                color: #222329;
                background: #fff;
                border: 1px solid #e8e9ee;
                font-size: 14px;
                font-weight: 400;
                height: 30px;
                width: 100px;
                border-radius: 4px;
            }

            .submit {
                outline: none;
                color: #fff;
                background: #5c70ff;
                border: none;
                box-shadow: inset -0.5px 0.5px rgba(0, 0, 0, .3), inset 0.5px -0.5px rgba(0, 0, 0, .3);
                font-size: 13px;
                font-weight: 400;
                padding: 0;
                height: 30px;
                width: 100px;
                border-radius: 4px;
            }
        }
    }
}

.folder-dialog {
    .moo-dialog__body {

        .content {
            display: flex;
            flex-flow: column;
            width: 100%;

            .folder-input {
                display: flex;
                flex-flow: row;
                justify-content: center;
                width: 100%;

                .folder-icon {
                    width: 35px;
                    height: 35px;
                    margin-right: 8px;
                }
            }

            .folder-path {
                margin-top: 2px;
                padding-left: 43px;
                font-size: 12px;
                color: rgba(0, 0, 0, .5);
            }
        }
    }
}

.common-input {
    display: block;
    flex: 1;

    input {
        height: 30px;
        border: 1px solid rgba(0, 0, 0, .3);
        border-radius: 4px;
        line-height: 30px;
    }
}
</style>
